/* Create a global app namespace */
window.App || (window.App = { });

App.init = function () {
  /* put global init code here */
  App.selectGatewayEnvironment();
  App.setupEditSiteForm();
  App.initCharts();
  App.openAnnounceGwModal();
  App.initSecretToggle();
  App.toggleGatewayActivationForm();
  App.conditionalFormElements();
  App.initActivationTokenInput();
  App.idpLoginForm();
}

document.addEventListener('turbo:load', function() {
  App.init()
})
